import angular from 'angular';
import { TermsOfUseComponent } from './terms-of-use.component';

export const TermsOfUseModule = angular
  .module('app.verify.terms-of-use', [])
  .component('updTermsOfUse', TermsOfUseComponent);
